import {CALENDAR_DATE_PICK} from "../../../enums/Request/currentRequestControls.types";

export const calendarDatePickCurrentRequest = ({field, date}) => {
    return {
        type: CALENDAR_DATE_PICK,
        payload: {field, date},
    };
};
